import { useState } from "react";

const useVideoPlayer = (videoElement) => {

  const [trimFlag,setTrimFlag] = useState(false);
  const [trimSection,setTrimSection] = useState(false);
  const [gifSection,setGifSection] = useState(false);
  const [operate,setOperate] = useState(false);
  const [trimProgress,setTrimProgress] = useState(false);
  const [gifFlag,setGifFlag] = useState(false);
  const [gifProgress,setGifProgress] = useState(false);

  const [playIcon,setPlayIcon] = useState(false);


  const [playerState, setPlayerState] = useState({
    isPlaying: false,
    progress: 0,
    speed: 1,
    isMuted: false,
    currentTime : 0,
    volume:50,
    length:null,
    start:0,
    end:0,
    fwdbck:false
  });

  const [trimplayerState, setTrimPlayerState] = useState({
    isPlaying: false,
    progress: 0,
    speed: 1,
    isMuted: false,
    currentTime : 0,
    volume:50,
    length:null,
    start:0,
    end:0,
    fwdbck:false
  });

  const [gifplayerState, setGifPlayerState] = useState({
    isPlaying: false,
    progress: 0,
    speed: 1,
    isMuted: false,
    currentTime : 0,
    volume:50,
    length:5,
    start:0,
    end:5,
    fwdbck:false
  });

  // console.log(videoElement)

  const togglePlay = () => {

    if(playerState.isPlaying){
      setPlayIcon(false)
      videoElement.current.pause()
    }else{
      setPlayIcon(true)
      videoElement.current.play()
    }

    setPlayerState({
        ...playerState,
        isPlaying: !playerState.isPlaying,
    });

  };

  const toggleTrimPlay = () =>{
    
    if(trimplayerState.isPlaying){
      setPlayIcon(false)
      videoElement.current.pause()
    }else{
      setPlayIcon(true)
      videoElement.current.play()
    }
    // console.log(!trimplayerState.isPlaying)

    setTrimPlayerState({
        ...trimplayerState,
        isPlaying: !trimplayerState.isPlaying
    });
  }

  const toggleGifPlay = (e) =>{
    e.preventDefault();
    // console.log(e,gifplayerState)
   
    if(gifplayerState.isPlaying){
      setPlayIcon(false)
      videoElement.current.pause()
    }else{
      setPlayIcon(true)
      videoElement.current.play()
    }

    setGifPlayerState({
        ...gifplayerState,
        isPlaying: !gifplayerState.isPlaying
    });

    // console.log(e,gifplayerState)
  }

  const handleVideoLength = (data)=>{
    // console.log(data)
    if(data.length || data.start || data.end){
      setPlayerState({
        ...playerState,
        start:data.start,
        end : data.end,
        length:data.length,
        isPlaying: false
      });

      // videoElement.current.currentTime = 0;

      setTrimFlag(true);
    }

    if(data.status && data.status === 'initial'){
      setOperate(false);
    }

    if(data.status && data.status === 'trimEvent'){
      setOperate(true);
    }

    // if(data.page)
    //   videoElement.current.currentTime = data.start;
  }

  const handleOnTimeUpdate = (e) => {

    // console.log(trimFlag)
    // console.log(videoElement.current.currentTime,playerState.start,videoElement.current.duration,trimFlag)
    let progress,currTime,playing = playIcon;
    if(trimFlag && operate){
      progress = ((videoElement.current.currentTime) / playerState.length) * 100;
    }else if(trimFlag){
      progress = ((videoElement.current.currentTime - playerState.start) / playerState.length) * 100;
    }else{
      progress = ((videoElement.current.currentTime) / videoElement.current.duration) * 100;
    }

    // console.log((Math.round(videoElement.current.currentTime - playerState.start) / playerState.length) * 100)
    // console.log(progress)
    
    if(Math.floor(progress) >= 100){
      progress = 100;
      playing = false;
    }else if(progress === 0){
      playing = false;
      progress = 0;
      videoElement.current.pause()
    }

    if(Math.floor(progress) < 0){
      progress = 0;
    }

    if(playerState.fwdbck){
      playing = false;
      videoElement.current.pause()
      setPlayIcon(false)
    }

    if(trimFlag && operate){
      currTime = parseInt((videoElement.current.currentTime))
    }else if(trimFlag){
      currTime = parseInt((videoElement.current.currentTime) - playerState.start)
    }else{
      currTime = parseInt((videoElement.current.currentTime))
    }
    

    if(playerState.length && currTime >= playerState.length){
      currTime = playerState.length
      playing = false;
    }

    if(trimFlag && (playerState.currentTime === playerState.length)){
      playing = false;
      videoElement.current.pause()
      videoElement.current.load() 
    }

    // console.log(videoElement.current.currentTime,currTime,trimFlag,videoElement)

    setPlayerState({
      ...playerState,
      progress:Math.floor(progress),
      currentTime : currTime,
      isPlaying : playing,
      fwdbck:false
    });

  };
    
  const handleVideoProgress = (value) => {
    // console.log(value);
    const manualChange = Number(value);
    let currentTime;
    // console.log(manualChange)
    if(trimFlag){
      currentTime = (( playerState.length * manualChange ) / 100 );
    }else{
      currentTime = (videoElement.current.duration / 100) * manualChange;
    }

    // console.log(currentTime)

    videoElement.current.currentTime = currentTime;

    // console.log(currentTime)
    setOperate(true)
    
    setPlayerState({
      ...playerState,
      // progress: manualChange,
      isPlaying:false,
      fwdbck:true,
      currentTime : currentTime
    });
  };

  const handleVideoSpeed = (event) => {
    const speed = Number(event.target.value);
    videoElement.current.playbackRate = speed;
    setPlayerState({
      ...playerState,
      speed,
    });
  };

  const toggleMute = () => {
    setPlayerState({
      ...playerState,
      isMuted: !playerState.isMuted,
    });

    playerState.isMuted
      ? (videoElement.current.muted = true)
      : (videoElement.current.muted = false);
  };

  const handleAudioLevel = (value) =>{
    // console.log(value);
    if(value > 0){
      setPlayerState({
        ...playerState,
        isMuted: false,
        volume: value,
      });
      // console.log(value);
    }else{
      setPlayerState({
        ...playerState,
        volume: value,
        isMuted: true,
      });
    }

    playerState.isMuted
    ? (videoElement.current.muted = true)
    : (videoElement.current.muted = false);
  }

  const handleEndVideo = (e) =>{
    console.log("ended"+e)
  }

  const handleTrimVideoLength = (data)=>{
    // console.log(data)
    if(data.length || data.start || data.end){
      setTrimPlayerState({
        ...trimplayerState,
        start:data.start,
        end : data.end,
        length:data.length,
        isPlaying: false
      });

      setTrimFlag(true);
    }
  }

  const handleTrimOnTimeUpdate = (e) =>{  
    // console.log(trimFlag)
    // console.log(videoElement.current.currentTime,trimplayerState,videoElement.current.duration,trimProgress,trimSection)
    let progress,currTime,playing = playIcon;

    if(trimProgress){
      progress = ((videoElement.current.currentTime) / trimplayerState.length) * 100;
    }else if(trimSection){
      progress = ((videoElement.current.currentTime - trimplayerState.start) / trimplayerState.length) * 100;
    }
    // console.log((Math.round(videoElement.current.currentTime - playerState.start) / playerState.length) * 100)
    // console.log(progress)
    
    if(Math.floor(progress) >= 100){
      progress = 100;
      playing = false;
    }else if(progress === 0){
      playing = false;
      progress = 0;
      videoElement.current.pause()
    }

    if(Math.floor(progress) < 0){
      progress = 0;
    }

    if(trimplayerState.fwdbck){
      playing = false;
      videoElement.current.pause()
    }

    if(trimProgress){
      currTime = parseInt((videoElement.current.currentTime))
    }else if(trimSection){
      currTime = parseInt((videoElement.current.currentTime) - trimplayerState.start)
    }else{
      currTime = parseInt((videoElement.current.currentTime))
    }
    // console.log(videoElement.current.currentTime,currTime)

    if(trimplayerState.length && currTime >= trimplayerState.length){
      currTime = trimplayerState.length
      playing = false;
    }

    if(trimFlag && (trimplayerState.currentTime === trimplayerState.length)){
      playing = false;
      videoElement.current.pause()
      videoElement.current.load() 
      setTrimProgress(false)
    }

    setTrimPlayerState({
      ...trimplayerState,
      progress:Math.floor(progress),
      currentTime : currTime,
      isPlaying : playing,
      fwdbck:false
    });

  }

  const handleTrimVideoProgress = (value) => {
    // console.log(value);
    const manualChange = Number(value);
    let currentTime;
    // console.log(manualChange,trimFlag,trimplayerState)
    if(trimFlag){
      currentTime = (( trimplayerState.length * manualChange ) / 100 );
    }else{
      currentTime = (videoElement.current.duration / 100) * manualChange;
    }

    // console.log(currentTime)

    videoElement.current.currentTime = currentTime;

    // console.log(currentTime)
    setTrimProgress(true)

    setTrimPlayerState({
      ...trimplayerState,
      isPlaying:false,
      fwdbck:true
    });
    
  };

  const handleShowTrimSection = (value) =>{
    setTrimSection(value)
  }

  //gif functionality
  const handleShowGifSection = (value) =>{
    setGifSection(value)
  }

  const handleGifOnTimeUpdate = () =>{
    // console.log(videoElement.current.currentTime,gifplayerState,videoElement.current.duration,gifFlag)
    let progress,currTime,playing = playIcon;

    if(gifProgress){
      progress = ((videoElement.current.currentTime) / gifplayerState.length) * 100;
    }else if(gifFlag){
      progress = ((videoElement.current.currentTime - gifplayerState.start) / gifplayerState.length) * 100;
    }else if(gifSection){
      progress = (videoElement.current.currentTime / gifplayerState.length) * 100;
    }
    // console.log((Math.round(videoElement.current.currentTime - playerState.start) / playerState.length) * 100)
    // console.log(progress)
    
    if(Math.floor(progress) >= 100){
      progress = 100;
      playing = false;
    }else if(progress === 0){
      playing = false;
      progress = 0;
      videoElement.current.pause()
    }

    if(Math.floor(progress) < 0){
      progress = 0;
    }

    if(gifplayerState.fwdbck){
      playing = false;
      videoElement.current.pause()
    }

    if(gifProgress){
      currTime = parseInt((videoElement.current.currentTime))
    }else if(gifFlag){
      currTime = parseInt((videoElement.current.currentTime-gifplayerState.start))
    }else if(gifSection){
      currTime = parseInt((videoElement.current.currentTime))
    }
    // console.log(videoElement.current.currentTime,currTime)

    if(gifplayerState.length && currTime >= gifplayerState.length){
      currTime = gifplayerState.length
      playing = false;
    }

    if(gifplayerState.currentTime === gifplayerState.length){
      playing = false;
      videoElement.current.pause()
      videoElement.current.load() 
      // setGifFlag(false)
    }

    setGifPlayerState({
      ...gifplayerState,
      progress:Math.floor(progress),
      currentTime : currTime,
      isPlaying : playing,
      fwdbck:false
    });

  }

  const handleGifVideoLength = (data) =>{
    if(data.length || data.start || data.end){
      setGifPlayerState({
        ...gifplayerState,
        start:data.start,
        end : data.end,
        length:data.length,
        isPlaying: false
      });

      setGifFlag(true)
    }
  }

  const handleGifVideoProgress = (value) =>{
    // console.log(value);
    const manualChange = Number(value);
    let currentTime;
    // console.log(manualChange,gifSection)
    if(gifSection){
      currentTime = (( gifplayerState.length * manualChange ) / 100 );
    }else{
      currentTime = (videoElement.current.duration / 100) * manualChange;
    }

    // console.log(currentTime)

    videoElement.current.currentTime = currentTime;

    // console.log(currentTime)
    setGifProgress(true)

    setGifPlayerState({
      ...gifplayerState,
      isPlaying:false,
      fwdbck:true
    });
  }

  return {
    playerState,
    trimplayerState,
    gifplayerState,
    togglePlay,
    toggleTrimPlay,
    toggleGifPlay,
    handleOnTimeUpdate,
    handleTrimOnTimeUpdate,
    handleVideoProgress,
    handleTrimVideoProgress,
    handleGifVideoProgress,
    handleVideoSpeed,
    toggleMute,
    handleAudioLevel,
    handleVideoLength,
    handleTrimVideoLength,
    handleGifVideoLength,
    handleEndVideo,
    handleShowTrimSection,
    handleShowGifSection,
    handleGifOnTimeUpdate
  };
};

export default useVideoPlayer;